import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-bebaa88c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "lp-card lab-progress" }
const _hoisted_2 = { class: "lab-progress__main" }
const _hoisted_3 = { class: "lab-progress__label" }
const _hoisted_4 = { class: "lp-bar lp-bar--success" }
const _hoisted_5 = {
  key: 0,
  class: "lab-progress__note"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "w-100 d-flex justify-content-end",
  style: {"position":"absolute","top":"10px","right":"10px"}
}, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn btn-light",
    "data-bs-dismiss": "modal"
  }, "X")
], -1))
const _hoisted_7 = { class: "mb-12 d-flex justify-content-center" }
const _hoisted_8 = ["src"]
const _hoisted_9 = {
  class: "text-center",
  style: {"color":"#9203DD","font-size":"24px","font-weight":"bold"}
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", { class: "bi bi-check-circle-fill text-success fs-2" }, null, -1))
const _hoisted_11 = { style: {"font-weight":"bold","text-align":"center"} }
const _hoisted_12 = { class: "text-center" }
const _hoisted_13 = { class: "d-flex justify-content-between" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"width":"50%"} }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "/media/hc/lux_1.png",
    alt: "image",
    style: {"width":"110%"}
  })
], -1))
const _hoisted_15 = {
  class: "d-flex flex-column align-items-center justify-content-center mt-6",
  style: {"width":"50%"}
}
const _hoisted_16 = { style: {"font-weight":"bold","font-size":"16px"} }
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" Rank ")
const _hoisted_18 = { style: {"color":"#9203DD"} }
const _hoisted_19 = {
  class: "p-2",
  style: {"background":"#9203DD","border-radius":"5px","width":"90%","text-align":"center","font-weight":"bold"}
}
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bi bi-linkedin" }, null, -1))

import { computed, ref, watch } from 'vue';
import { useStore } from 'vuex';
import moment from 'moment';
import ApiService from '@/core/services/ApiService';
import AchivementModal from '@/components/achivements/modal.vue';
import HcIcon from '@/modern/components/ui/HcIcon.vue';
import { useLearningPathI18n } from '../view/learningPath';
import type { LabKind } from './labs';


export default /*#__PURE__*/_defineComponent({
  props: {
    kind: null,
    resource: null
  },
  setup(__props: any) {

const props = __props as {
  kind: LabKind
  resource: any
}



const store = useStore();
const { t, lang, tl } = useLearningPathI18n();

const user = computed(() => store.getters.currentUser);
const percentage = computed(() => Number(props.resource.percentage) || 0);
const totalFlags = computed(() => Number(props.resource.total_flags) || 0);
const flagsDone = computed(() => Math.round((percentage.value / 100) * totalFlags.value));
const isDone = computed(() => percentage.value >= 100);

const achivementModal = ref<InstanceType<typeof AchivementModal> | null>(null);
const userStats = ref<any>({});

const fetchUserStats = async () => {
  try {
    const { data } = await ApiService.vueInstance.axios.get(`/user-stats/${props.kind === 'challenge' ? 'challenges' : 'machines'}/${props.resource.id}`);
    userStats.value = data;
  } catch (error) {
    console.error('Error fetching user stats:', error);
  }
};

const openAchievement = async () => {
  await fetchUserStats();
  (achivementModal.value as any)?.open();
};

// Abre a conquista quando o progresso chega a 100% nesta visita
watch(() => props.resource, (value, old) => {
  if (value && old && value.id === old.id && Number(value.percentage) === 100 && Number(old.percentage) < 100) {
    openAchievement();
  }
});

const timeSpent = computed(() =>
  (moment.duration(userStats.value.time_spent || 0, 'seconds') as any)
    .format([moment.duration(1, 'minute'), moment.duration(1, 'day')], 'M[M] w[S] d[d] hh[h] mm[m] ss[s]', { trim: 'all' })
);

const shareOnLinkedin = () => {
  const url = `${process.env.VUE_APP_SHARE_URL}achievement/${props.kind}/${props.resource.id}/user/${user.value.id}`;
  window.open(`https://www.linkedin.com/sharing/share-offsite/?url=${url}`, '_blank');
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", _hoisted_3, [
        _createElementVNode("span", null, [
          _createElementVNode("strong", null, _toDisplayString(_unref(percentage)) + "%", 1),
          _createTextVNode(" " + _toDisplayString(_unref(tl)('percent_completed')), 1)
        ]),
        _createElementVNode("span", null, _toDisplayString(_unref(flagsDone)) + "/" + _toDisplayString(_unref(totalFlags)) + " flags", 1)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("span", {
          style: _normalizeStyle({ width: `${Math.min(_unref(percentage), 100)}%` })
        }, null, 4)
      ]),
      (_unref(isDone))
        ? (_openBlock(), _createElementBlock("p", _hoisted_5, [
            _createVNode(HcIcon, {
              name: "check",
              size: 16
            }),
            _createTextVNode(" " + _toDisplayString(__props.kind === 'challenge' ? _unref(tl)('challenge_done') : _unref(tl)('machine_done')), 1)
          ]))
        : _createCommentVNode("", true)
    ]),
    (_unref(isDone))
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          type: "button",
          class: "lp-btn",
          onClick: openAchievement
        }, [
          _createVNode(HcIcon, {
            name: "linkedin",
            size: 16
          }),
          _createTextVNode(" " + _toDisplayString(_unref(t)(`${_unref(lang)}.common.share_on_linkedin`)), 1)
        ]))
      : _createCommentVNode("", true),
    _createVNode(AchivementModal, {
      ref_key: "achivementModal",
      ref: achivementModal
    }, {
      header: _withCtx(() => [
        _createElementVNode("div", null, [
          _hoisted_6,
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("img", {
              src: __props.kind === 'machine' && __props.resource.photo_path ? __props.resource.photo_path : '/media/logos/machines/challs.png',
              class: "avatar-img img-fluid floating",
              style: {"width":"15%"},
              alt: "image"
            }, null, 8, _hoisted_8)
          ]),
          _createElementVNode("h3", _hoisted_9, [
            _createTextVNode(_toDisplayString(_unref(t)(`${_unref(lang)}.achivement.${__props.kind}.title`)) + " ", 1),
            _hoisted_10
          ])
        ])
      ]),
      body: _withCtx(() => [
        _createElementVNode("p", _hoisted_11, _toDisplayString(_unref(t)(`${_unref(lang)}.achivement.${__props.kind}.message_1`, { user: _unref(user).nick || 'No nick' })), 1),
        _createElementVNode("p", _hoisted_12, _toDisplayString(_unref(t)(`${_unref(lang)}.achivement.${__props.kind}.message_2`, { [__props.kind]: __props.resource.name })), 1),
        _createElementVNode("div", _hoisted_13, [
          _hoisted_14,
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("p", _hoisted_16, [
              _hoisted_17,
              _createElementVNode("span", _hoisted_18, " #" + _toDisplayString(userStats.value.ranking), 1)
            ]),
            _createElementVNode("div", _hoisted_19, _toDisplayString(_unref(timeSpent)), 1),
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-custom-achievement mt-12",
              onClick: shareOnLinkedin
            }, [
              _hoisted_20,
              _createTextVNode(" " + _toDisplayString(_unref(t)(`${_unref(lang)}.common.share_on_linkedin`)), 1)
            ])
          ])
        ])
      ]),
      _: 1
    }, 512)
  ]))
}
}

})